import dynamic from 'next/dynamic';

import { useBooleanFlags } from '@/domains/core/flags/flags.hooks';
import { isFrancePlatform } from '@/domains/core/settings/utils';
import { StringAbTests } from '@/domains/productDiscovery/ProductPage/constants';
import { useDetail } from '@/domains/productDiscovery/ProductPage/hooks/useDetail';

import styles from './labels.module.scss';

const EnergyLabel = dynamic(() =>
  import(
    '@/domains/productDiscovery/ProductPage/common/components/AddToCart/IndexLabels/EnergyLabel'
  ).then((mod) => mod.EnergyLabel),
);

const RepairabilityLabel = dynamic(() =>
  import(
    '@/core/tamagoshi/RepairabilityIndexRedesign/RepairabilityIndexRedesign'
  ).then((mod) => mod.RepairabilityIndexRedesign),
);

export const IndexLabels = () => {
  const { repairabilityIndex, attributes, energy } = useDetail();

  const [isProductPageRevampEnabled] = useBooleanFlags([
    StringAbTests.ENABLE_PRODUCT_PAGE_REVAMP,
  ]);

  if (isProductPageRevampEnabled) {
    return (
      <>
        <EnergyLabel attributes={attributes} energy={energy} />
        {repairabilityIndex && isFrancePlatform() && (
          <RepairabilityLabel
            index={repairabilityIndex}
            label="Indice de réparabilité"
          />
        )}
      </>
    );
  }

  return (
    <div className={styles.indexLabels}>
      <EnergyLabel attributes={attributes} energy={energy} />
      {repairabilityIndex && isFrancePlatform() && (
        <RepairabilityLabel
          index={repairabilityIndex}
          label="Indice de réparabilité"
        />
      )}
    </div>
  );
};
